<template>
    <div role="dialog">
        <transition name="fade">
            <div class="modal-backdrop" v-if="show" @click="closeModal"></div>
        </transition>
        <transition name="slide">
            <div class="modal-block" v-if="show" role="document" tabindex="-1">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <!-- <client-only>
                            <ion-icon name="close-outline" class="modal-close-btn" @click="closeModal"></ion-icon>
                        </client-only> -->
                        <!-- <slot></slot> -->
                        <div v-html="content"></div>
                        <i class="material-icons modal-close-btn" @click="closeModal">close</i>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Dialog',
    props: ['show', 'content'],
    methods: {
        closeModal() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";
    div[role="dialog"] {
        background:$white;
        z-index:1000;

        .modal-backdrop {
            background:rgba($black,.7);
            position:fixed;
            top:0;
            left:0;
            bottom:0;
            right:0;
            z-index: 1040;
        }

        .modal-block {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1050;
            -webkit-overflow-scrolling: touch;
            outline: 0;
            pointer-events: none;
        }

        .modal-dialog {
            max-width:630px;
            margin:10px auto;
            pointer-events: all;
        }

        .modal-dialog .modal-close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            padding: 10px;
            border: 1px solid rgba($black-variant,.5);
            color: rgba($black-variant,.5);
            cursor: pointer;
            transition: color .3s ease, border .3s ease;

            &:hover,
            &:focus,
            &:active {
                color:$red;
                border:1px solid $red;
            }
        }

        .modal-dialog .modal-content {
            top: 36px;
            width: 100%;
            border-radius: 0;
            // box-shadow: $base-box-shadow;
            margin: 0 auto;
            padding:40px 18px 40px 18px;
            max-width: 90%;
            max-height: 90vh;
            overflow: auto;
            background-color: $white;
            background-clip: padding-box;
            outline: 0;
            position: relative;

            @media screen and (min-width:640px) {
                padding:50px;
            }

            @media screen and (min-width:992px) {
                max-width:100%;
                padding:95px 90px;
            }
        }
    }

    .fade-enter-active, .fade-leave-active {
        opacity:1;
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity:0;
    }

    .slide-enter-active, .slide-leave-active {
        transform:translateY(0);
        opacity:1;
        transition: transform .3s, opacity .3s;
    }
    .slide-enter, .slide-leave-to {
        transform:translateY(-25%);
        opacity:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue